// extracted by mini-css-extract-plugin
module.exports = {"main":"WhatYouKnow_main_JGjq0","mobile":"WhatYouKnow_mobile_14LFQ","title":"WhatYouKnow_title_2efW5","content":"WhatYouKnow_content_2yXFR"};